// Planned against actual, read only: the planner's shifts (resource
// "schedules") next to attendance. A shift belongs to the day it starts on,
// as an attendance record belongs to the day of its check-in, so a night
// shift meets its record on the same date. Payroll keeps reading attendance
// only; nothing here changes a record.
import { cellKey } from './weekModel';

/** "06:00–18:00", or "18:00–06:00 (+1)" when it ends the next day */
export const shiftTimes = (shift) => {
  const day = shift.starts_at.slice(0, 10);
  const end = shift.ends_at.slice(11, 16);
  return `${shift.starts_at.slice(11, 16)}–${end}${shift.ends_at.slice(0, 10) > day ? ' (+1)' : ''}`;
};

/** The planned shifts by cellKey(employee, start date) */
export const planByCell = (shifts) => {
  const map = new Map();
  (shifts || []).forEach((s) => {
    const key = cellKey(s.employee_id, s.starts_at.slice(0, 10));
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(s);
  });
  return map;
};

/** "Gate 06:00–18:00 · Depot 20:00–23:00" */
export const planLine = (shifts) => (shifts || []).map((s) => `${s.site_name} ${shiftTimes(s)}`).join(' · ');

export const plannedHours = (shifts) => (shifts || []).reduce((sum, s) => sum + (Number(s.hours) || 0), 0);

const AWAY_KINDS = ['absent', 'sick', 'leave', 'unpaid'];

/**
 * What the plan says about one day of the week grid ('' = nothing):
 * planned but no record once the day is over, or planned but the day is an
 * absence, sickness or leave.
 */
export const planFlag = (shifts, kind, date, today, t) => {
  if (!shifts || shifts.length === 0) return '';
  if (kind === 'empty') return date < today ? t('Planned, no record') : '';
  if (AWAY_KINDS.includes(kind)) return t('Planned, not worked');
  return '';
};

/**
 * Today: a planned shift that has started while the guard is not in yet.
 * `now` is "YYYY-MM-DDTHH:mm" in Suriname time; returns the earliest such
 * start ("HH:mm") or ''.
 */
export const notInSince = (shifts, state, now) => {
  if (state !== 'not_in') return '';
  const started = (shifts || []).filter((s) => s.starts_at <= now && s.ends_at > now).map((s) => s.starts_at);
  return started.length ? started.sort()[0].slice(11, 16) : '';
};
